import { Crop169, HowToVote } from '@mui/icons-material';
import { Row } from 'components/Basic/Basic.styles';
import { useLanguage } from 'context/AppContext';
import React, { Dispatch, FC, SetStateAction } from 'react';
import { ModalContentType } from '../SetModal';
import {
  SetModalContainer,
  SetModalButton,
  SetModalButtonContent,
  SetModalButtonText,
  SetModalDivider,
} from '../SetModal.styles';

interface SelectItemProps {
  setModalContent: Dispatch<SetStateAction<ModalContentType>>;
}

// Workflow to select what item will be added to the set (tray or part)
const SelectItem: FC<SelectItemProps> = ({ setModalContent }) => {
  const [language] = useLanguage();
  return (
    <SetModalContainer>
      <Row>
        <SetModalButton onClick={() => setModalContent('selectTray')}>
          <SetModalButtonContent>
            <Crop169 fontSize="inherit" />
            <SetModalButtonText>{language.AddModal.Item.tray}</SetModalButtonText>
          </SetModalButtonContent>
        </SetModalButton>
        <SetModalDivider />
        <SetModalButton onClick={() => setModalContent('selectPart')}>
          <SetModalButtonContent>
            <HowToVote fontSize="inherit" />
            <SetModalButtonText>{language.AddModal.Item.device}</SetModalButtonText>
          </SetModalButtonContent>
        </SetModalButton>
      </Row>
    </SetModalContainer>
  );
};

export default SelectItem;
